//Children
import React from "react";

export default function getChilds(children,type) {
    let list=[];
    React.Children.forEach(children, function(child){
        if(child.props.type==="type"){
            list.push(child);
        }
    });
    return list;
};

